export default __webpack_public_path__ + "static/fa-solid-900-1bb22a28d698303a1b75b749062cb0ad.svg";